'use client';

import { GTMLanguageSwitch } from '@/lib/analytics';
import useCommonStore from '@/store/commonStore';
import { useEffect } from 'react';

export default function LangProvider({ children }: { children: React.ReactNode }) {

    const { setTranslations, language,updateUserLanguageAndCurrency } = useCommonStore()

    const fetchTranslations = async () => {
        return await setTranslations()
    }
    useEffect(() => {
        const cookieLang = document.cookie
            .split('; ')
            .find(row => row.startsWith('lang='))
            ?.split('=')[1];
        const cookieCurrency = document.cookie
            .split('; ')
            .find(row => row.startsWith('currency='))
            ?.split('=')[1];
        if (cookieLang && cookieLang !== language?.value) {
            GTMLanguageSwitch(language?.value, cookieLang)
            // Update store with cookie language
            updateUserLanguageAndCurrency(cookieLang,cookieCurrency);
        }
        if (typeof document !== "undefined") {
            document.documentElement.dir = language?.value === "AR" ? "rtl" : "ltr";
        }
        fetchTranslations()
    }, [language]);
    return children;
}